import React, { createContext, PropsWithChildren, useContext } from 'react';
import { SEOTableData } from 'src/api/models/SEOTable';

type SEOTableContextProps = SEOTableData & {
  getTemplateColumnsSet: (firstColumnCustomWidth: number, columnCount: number) => string;
  columnCount: number;
};

const SEOTableContext = createContext<SEOTableContextProps | undefined>(undefined);

interface SEOTableProviderProps extends PropsWithChildren {
  config: SEOTableData;
}

export const SEOTableProvider = ({ children, config }: SEOTableProviderProps): JSX.Element => {
  const getTemplateColumnsSet = (firstColumnCustomWidth: number, columnCount: number): string => {
    if (firstColumnCustomWidth) {
      return `${firstColumnCustomWidth}px repeat(${columnCount - 1}, 1fr)`;
    }

    return `repeat(${columnCount}, 1fr)`;
  };

  return (
    <SEOTableContext.Provider
      value={{
        ...config,
        getTemplateColumnsSet,
        columnCount: config.head.length + 1,
      }}
    >
      {children}
    </SEOTableContext.Provider>
  );
};

export const useSEOTableConfig = (): SEOTableContextProps => {
  const context = useContext(SEOTableContext);

  if (!context) {
    throw new Error('useSEOTableConfig must be used within a SEOTableProvider');
  }

  return context;
};
